var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm"
  }, [_c('square-title', [_vm._v("인증마크")]), _c('div', {
    staticClass: "tit-wrap"
  }, [_c('marks-list')], 1), _c('v-row', {
    attrs: {
      "no-gutters": "",
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "x-large": "",
      "color": "primary"
    },
    on: {
      "click": _vm.tempMsg
    }
  }, [_vm._v("OEM/ODM 문의하기")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }